import { AbilityBuilder, createMongoAbility } from "@casl/ability";
import { Actions, Subjects } from "./constants";
import { roles } from "../types/authTypes";

export default function defineAbilityFor(user) {
  const { can, cannot, build } = new AbilityBuilder(createMongoAbility);

  // Own Info
  /*** PASSWORD_UPDATE - TWOFA_VIEW - TWOFA_UPDATE */
  can(Actions.UPDATE, Subjects.USER, { userId: user.userId });

  // VISITOR ROL
  if (user.role === roles.VISITOR) {
    can(Actions.VIEW, Subjects.MENU);
    can(Actions.VIEW, Subjects.MENU_MY_COLLECTION);
    cannot(Actions.VIEW, Subjects.MENU_SALE_HISTORY);
    can(Actions.VIEW, Subjects.MENU_SHOP);
    can(Actions.VIEW, Subjects.MENU_SHIRTS_COLLECTIONS);
    can(Actions.VIEW, Subjects.MENU_COMMUNITY);
    cannot(Actions.VIEW, Subjects.MENU_BLOG);
    can(Actions.VIEW, Subjects.MENU_SEARCH_FOR_COLLECTORS);

    can(Actions.VIEW, Subjects.SIGN_UP_BUTTON);
    can(Actions.VIEW, Subjects.UPGRADE_MEMBERSHIP);
    cannot(Actions.VIEW, Subjects.USER);
    cannot(Actions.VIEW_PURCHASING_VALUE, Subjects.COLLECTION);
    cannot(Actions.VIEW_CURRENT_VALUE, Subjects.COLLECTION);
    cannot(Actions.VIEW_VIRTUAL_PROFIT, Subjects.COLLECTION);
    cannot(Actions.UPDATE_VISIBILITY, Subjects.COLLECTION);
    cannot(Actions.VIEW_FINANCIAL_DATA, Subjects.STATS);
    cannot(Actions.UPDATE_FINANCIAL_VISIBILITY, Subjects.STATS);
    cannot(Actions.VIEW_NUMERIC_DATA, Subjects.STATS);
    cannot(Actions.UPDATE_NUMERIC_VISIBILITY, Subjects.STATS);
    cannot(Actions.VIEW, Subjects.PREMIUM_BADGE);
    cannot(Actions.UPDATE_VISIBILITY, Subjects.SHIRT);
    cannot(Actions.UPDATE_OPEN_OFFERS, Subjects.SHIRT);
    cannot(Actions.UPDATE, Subjects.TOP10);
    cannot(Actions.VIEW_CURRENT_VALUE, Subjects.TOP10);
    cannot(Actions.VIEW_ITEM_VALUE, Subjects.TOP10);
    cannot(Actions.VIEW, Subjects.COMMUNITY);
    cannot(Actions.VIEW, Subjects.TOP_COLLECTORS);
    cannot(Actions.DO, Subjects.LEGIT_CHECK);
    cannot(Actions.VIEW, Subjects.LEGIT_CHECK);
  }

  // FREE ROL
  if (user.role === roles.FREE) {
    can(Actions.VIEW, Subjects.MENU);
    can(Actions.VIEW, Subjects.MENU_MY_COLLECTION);
    can(Actions.VIEW, Subjects.MENU_SALE_HISTORY);
    can(Actions.VIEW, Subjects.MENU_SHOP);
    can(Actions.VIEW, Subjects.MENU_SHIRTS_COLLECTIONS);
    can(Actions.VIEW, Subjects.MENU_COMMUNITY);
    can(Actions.VIEW, Subjects.MENU_BLOG);
    can(Actions.VIEW, Subjects.MENU_SEARCH_FOR_COLLECTORS);

    can(Actions.VIEW, Subjects.UPGRADE_MEMBERSHIP);
    can(Actions.VIEW, Subjects.COLLECTION);
    can(Actions.VIEW, Subjects.USER);
    can(Actions.VIEW_PURCHASING_VALUE, Subjects.COLLECTION, {
      owner: user.userId,
    });
    cannot(Actions.VIEW_CURRENT_VALUE, Subjects.COLLECTION);
    cannot(Actions.VIEW_VIRTUAL_PROFIT, Subjects.COLLECTION, {
      owner: user.userId,
    });
    cannot(Actions.UPDATE_VISIBILITY, Subjects.COLLECTION);
    cannot(Actions.VIEW_FINANCIAL_DATA, Subjects.STATS);
    cannot(Actions.UPDATE_FINANCIAL_VISIBILITY, Subjects.STATS);
    cannot(Actions.VIEW_NUMERIC_DATA, Subjects.STATS);
    cannot(Actions.UPDATE_NUMERIC_VISIBILITY, Subjects.STATS);
    can(Actions.VIEW, Subjects.PREMIUM_BADGE);
    can(Actions.VIEW_PURCHASING_VALUE, Subjects.SHIRT, { owner: user.userId });
    cannot(Actions.VIEW_CURRENT_VALUE, Subjects.SHIRT);
    can(Actions.UPDATE, Subjects.SHIRT, { owner: user.userId });
    cannot(Actions.UPDATE_VISIBILITY, Subjects.SHIRT);
    cannot(Actions.UPDATE_OPEN_OFFERS, Subjects.SHIRT);
    can(Actions.UPDATE, Subjects.TOP10);
    cannot(Actions.VIEW_CURRENT_VALUE, Subjects.TOP10);
    cannot(Actions.VIEW_ITEM_VALUE, Subjects.TOP10);
    can(Actions.VIEW, Subjects.COMMUNITY);
    can(Actions.VIEW, Subjects.TOP_COLLECTORS);
    cannot(Actions.DO, Subjects.LEGIT_CHECK);
    can(Actions.VIEW, Subjects.LEGIT_CHECK);
  }

  // PREMIUM ROL
  if (user.role === roles.PREMIUM) {
    can(Actions.VIEW, Subjects.MENU);
    can(Actions.VIEW, Subjects.MENU_MY_COLLECTION);
    can(Actions.VIEW, Subjects.MENU_SALE_HISTORY);
    can(Actions.VIEW, Subjects.MENU_SHOP);
    can(Actions.VIEW, Subjects.MENU_SHIRTS_COLLECTIONS);
    can(Actions.VIEW, Subjects.MENU_COMMUNITY);
    can(Actions.VIEW, Subjects.MENU_BLOG);
    can(Actions.VIEW, Subjects.MENU_SEARCH_FOR_COLLECTORS);

    cannot(Actions.VIEW, Subjects.UPGRADE_MEMBERSHIP);
    can(Actions.VIEW, Subjects.COLLECTION);
    can(Actions.VIEW, Subjects.USER);
    can(Actions.VIEW_PURCHASING_VALUE, Subjects.COLLECTION, {
      owner: user.userId,
    });
    can(Actions.VIEW_CURRENT_VALUE, Subjects.COLLECTION);
    can(Actions.VIEW_VIRTUAL_PROFIT, Subjects.COLLECTION, {
      owner: user.userId,
    });
    can(Actions.UPDATE_VISIBILITY, Subjects.COLLECTION);
    can(Actions.VIEW_FINANCIAL_DATA, Subjects.STATS);
    can(Actions.UPDATE_FINANCIAL_VISIBILITY, Subjects.STATS);
    can(Actions.VIEW_NUMERIC_DATA, Subjects.STATS);
    can(Actions.UPDATE_NUMERIC_VISIBILITY, Subjects.STATS);
    can(Actions.VIEW, Subjects.PREMIUM_BADGE);
    can(Actions.UPDATE, Subjects.SHIRT, { owner: user.userId });
    can(Actions.VIEW_PURCHASING_VALUE, Subjects.SHIRT, { owner: user.userId });
    can(Actions.VIEW_CURRENT_VALUE, Subjects.SHIRT);
    can(Actions.UPDATE_VISIBILITY, Subjects.SHIRT, { owner: user.userId });
    can(Actions.UPDATE_OPEN_OFFERS, Subjects.SHIRT, { owner: user.userId });
    can(Actions.UPDATE, Subjects.TOP10);
    can(Actions.VIEW_CURRENT_VALUE, Subjects.TOP10);
    can(Actions.VIEW_ITEM_VALUE, Subjects.TOP10);
    can(Actions.VIEW, Subjects.COMMUNITY);
    can(Actions.VIEW, Subjects.TOP_COLLECTORS);
    can(Actions.DO, Subjects.LEGIT_CHECK);
    can(Actions.VIEW, Subjects.LEGIT_CHECK);
  }

  return build();
}
